import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentBayonetToken, setBayonet, initialState } from './bayonet.slice';
import { useGenerateFingerprintTokenMutation } from './bayonet.api';

const jsKey = process.env.NEXT_PUBLIC_BAYONET_JS_KEY;

const errorState = {
  bayonet_fingerprint_token: null,
  bayonetFingerprintToken: null,
  status: 'error',
  reasonCode: 0,
  reasonMessage: 'error',
};

const useBayonet = () => {
  const dispatch = useDispatch();
  const bayonet = useSelector(selectCurrentBayonetToken);
  const [request] = useGenerateFingerprintTokenMutation();

  const setBayonetCurrentToken = (token) => {
    dispatch(setBayonet(token));
  };

  const loadToken = async () => {
    try {
      if (jsKey) {
        const { data, error } = await request(jsKey);
        if (data) {
          const { payload, reasonCode, reasonMessage } = data;
          setBayonetCurrentToken({
            bayonet_fingerprint_token: payload?.bayonetFingerprintToken || '',
            bayonetFingerprintToken: payload?.bayonetFingerprintToken || '',
            status: reasonMessage,
            reasonCode,
            reasonMessage,
          });
        } else {
          setBayonetCurrentToken({
            ...errorState,
            status: error?.data?.reasonMessage || 'error',
            reasonMessage: error?.data?.reasonMessage || 'error',
            reasonCode: error?.data?.reasonCode || 0,
          });
        }
      }
    } catch (e) {
      setBayonetCurrentToken(errorState);
    }
  };

  const load = async () => {
    setBayonetCurrentToken(initialState);
    await loadToken();
  };

  const reload = async () => {
    if (!bayonet || !bayonet.bayonetFingerprintToken) {
      await loadToken();
    }
  };

  return {
    bayonet,
    load,
    reload,
  };
};

export default useBayonet;
